var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinklerRecalc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SPRINKLER_RECALC",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            #SPRINKLER_RECALC .cls-1,\n            #SPRINKLER_RECALC .cls-2{\n                fill:#f5f5f5\n            }\n            #SPRINKLER_RECALC .cls-2{\n                stroke:rgba(0,0,0,0);\n                stroke-miterlimit:10\n            }\n            #SPRINKLER_RECALC .cls-3{\n                filter:url(#Vereinigungsmenge_20)\n            }\n            #SPRINKLER_RECALC .cls-4{\n                filter:url(#Differenzmenge_2)\n            }\n        "), /*#__PURE__*/React.createElement("filter", {
    id: "Differenzmenge_2",
    width: 39.862,
    height: 42,
    x: 0,
    y: 0.374,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_20",
    width: 37.834,
    height: 29.359,
    x: 4.543,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "translate(26 -12), rotate(45), scale(1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    strokeWidth: 4,
    d: "M18,5.7h-.5l4.3-4.3L20.4,0,13.7,6.7l6.7,6.7L21.8,12,17.5,7.7H18a16,16,0,1,1-16,16v-.1H0v.1a18,18,0,1,0,18-18Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_12)",
    transform: "translate(3,2) scale(0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_12-2",
    "data-name": "Vereinigungsmenge 12",
    className: "cls-1",
    d: "M5044.8-2767.8v-2h2v2Zm8.266-4.655,1.415-1.413,1.415,1.413-1.415,1.414Zm-17.428-.064,1.415-1.414,1.414,1.414-1.414,1.415Zm9.162.719v-2h2v2Zm5.478-3.48,1.415-1.414,1.414,1.414-1.414,1.415Zm-11.81-.028,1.413-1.415,1.415,1.415-1.415,1.414Zm1.632-5.891a5.7,5.7,0,0,1,5.7-5.7,5.7,5.7,0,0,1,5.7,5.7,5.7,5.7,0,0,1-5.7,5.7A5.634,5.634,0,0,1,5040.1-2781.2Zm2,0a3.757,3.757,0,0,0,3.7,3.7,3.757,3.757,0,0,0,3.7-3.7,3.757,3.757,0,0,0-3.7-3.7A3.757,3.757,0,0,0,5042.1-2781.2Zm1.7,0a2,2,0,0,1,2-2,2,2,0,0,1,2,2,2,2,0,0,1-2,2A2,2,0,0,1,5043.8-2781.2Zm13.4,1v-2h2v2Zm-4,0v-2h2v2Zm-16.8,0v-2h2v2Zm-4,0v-2h2v2Zm17.9-6.89,1.415-1.415,1.414,1.415-1.414,1.413Zm-11.81-.028,1.413-1.414,1.415,1.414-1.415,1.415Zm14.638-2.763,1.415-1.414,1.415,1.414-1.415,1.415Zm-17.426-.065,1.413-1.414,1.415,1.414-1.415,1.415Zm9.095,1.346v-2h2v2Zm0-4v-2h2v2Z",
    transform: "translate(-5024.8 2802.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinklerRecalc);
export default __webpack_public_path__ + "static/media/sprinkler-recalc.bed90551f9534340216525a6203a790f.svg";
export { ForwardRef as ReactComponent };